import Action from '../actions/model'
import Insight from '../insights/model'
import Model from '../../model'
import Metric from '../metrics/model'

export default class Chart extends Model {
    constructor(...attributes) {
        super(...attributes)

        if (!this.query_settings) {
            this.query_settings = {
                action: {
                    filters: {},
                    limit: 3,
                    loading: false,
                    pagination: {
                        current_page: 1,
                        from: null,
                        last_page: null,
                        path: null,
                        per_page: null,
                        to: null,
                        total: null
                    },
                    sortBy: 'state,-created_at',
                },
                insight: {
                    filters: {},
                    limit: 3,
                    loading: false,
                    pagination: {
                        current_page: 1,
                        from: null,
                        last_page: null,
                        path: null,
                        per_page: null,
                        to: null,
                        total: null
                    },
                    sortBy: '-created_at',
                },
            }
        }
    }

    resource()
    {
        return 'charts'
    }

    favourited() {
        let endpoint = `${this.baseURL()}/favourited-charts`

        return this.request({
            method: 'POST',
            url: endpoint,
            data: {chart_id: this.id}
        }).then(response => {
            return response.data.data
        })
    }

    unfavourited(user_id) {
        let endpoint = `${this.baseURL()}/favourited-charts`
        let favourite = this.favourites.find(f => f.user.id === user_id)

        return this.request({
            method: 'DELETE',
            url: `${endpoint}/${favourite.id}`,
        }).then(response => {
            return response.data.data
        })
    }

    getData() {
        let endpoint = `${this.baseURL()}/charts/${this.id}/data`
        let query = null

        if (this.start_date) {
            query = `start_date=${this.start_date}`

            if (this.end_date) {
                query = `${query}&end_date=${this.end_date}`
            }
        }

        if (query) {
            endpoint = `${endpoint}?${query}`
        }

        return this.request({
            method: 'GET',
            url: endpoint,
        }).then(response => {
            return response.data.data
        })
    }

    getGivers() {
        let endpoint = `${this.baseURL()}/charts/${this.id}/givers`

        return this.request({
            method: 'GET',
            url: endpoint,
        }).then(response => {
            return response.data.data
        })
    }

    getMetricData (data_source) {
        let endpoint = `${this.baseURL()}/metric-data`

        return this.request({
            method: 'POST',
            url: endpoint,
            data: {data_source: data_source}
        }).then(response => {
            return response.data.data
        })
    }

    chartActions() {
        return this.hasMany(Action)
    }

    chartInsights() {
        return this.hasMany(Insight)
    }

    chartMetrics() {
        return this.hasMany(Metric)
    }

    sendExportReport(id) {
        let url = `${this.baseURL()}/reports/export${this._builder.query()}`

        return this.request({
            method: 'POST',
            url: url,
            data: {client_id: id}
        }).then(response => {
            return response.data
        })
    }

    _create() {
        let self = {...this}

        delete self.type
        delete self.client
        delete self.datasets
        delete self.dimensions
        delete self.loading

        return this.request({
            method: 'POST',
            url: this.endpoint(),
            data: self
        }).then(response => {
            self = Object.assign(this, response.data.data)

            return self
        })
    }

    _update() {
        let self = {...this}

        delete self.type
        delete self.client
        delete self.datasets
        delete self.dimensions
        delete self.loading

        return this.request({
            method: 'PUT',
            url: this.endpoint(),
            data: self
        }).then(response => {
            self = Object.assign(this, response.data.data)

            return self
        })
    }
}
